export default __webpack_public_path__ + "static/media/promoMobile.c57b9ffa.png";